import { select, take, takeLatest } from "redux-saga/effects";

import GaReporter from "../../../utilities/gaReporter";
import { CONFIGURATION_LOADED } from "../../actions/configurationActions";
import { SET_SESSION_DATA } from "../../actions/sessionActions";
import { getCurrencyForAnalytics, getDealerAccount, getFrontendSettings, getModelId, getShowPrice } from "../selectors";

export function* initGoogleAnalyticsSaga(): any {
    yield take(SET_SESSION_DATA);

    const frontendSettings = yield select(getFrontendSettings);
    if (!frontendSettings.ga_tracking_enabled) {
        return;
    }

    const dealer = yield select(getDealerAccount);

    // Allow reporting both to a GA property common for all DS apps, and a GA property
    // for a specific customer which we can share to them.
    const measurementIds: string[] = [];
    if (frontendSettings.ga_common_measurement_id) {
        measurementIds.push(frontendSettings.ga_common_measurement_id);
    }

    if (dealer) {
        const dealerMeasurementId = frontendSettings[`ga_measurement_id_${dealer}`];
        if (dealerMeasurementId) {
            measurementIds.push(dealerMeasurementId);
        }
    }

    if (measurementIds.length === 0) {
        return;
    }

    const siteUrl = new URL(window.location.href);
    const cookiePath = siteUrl.pathname.replace(/\/[^/]+\/?$/i, "") || "/";
    const useCookies = /true/i.test(siteUrl.searchParams.get("use_ga_cookie") || "");
    const applicationType = siteUrl.searchParams.get("ga_application_type") || "Web";

    GaReporter.initTracking(measurementIds, useCookies, cookiePath, applicationType);
    if (frontendSettings.ga_tracking_project) {
        GaReporter.setProject(frontendSettings.ga_tracking_project);
    }

    const showPrice = yield select(getShowPrice);
    if (showPrice) {
        const currency = yield select(getCurrencyForAnalytics);
        if (currency) {
            GaReporter.setCurrency(currency);
        }
    }

    if (dealer) {
        GaReporter.setDealerId(dealer);
    }

    GaReporter.trackPageView();
}

export function* updateGoogleAnalyticsModelIdSaga(): any {
    yield takeLatest(CONFIGURATION_LOADED, function* (): any {
        const modelId = yield select(getModelId);
        GaReporter.setModelId(modelId);
    });
}
